module.exports = __webpack_public_path__ + "img/schafalpenkopf.a4cdd682.jpg";